import React, { useState, useEffect } from 'react';
import { Link } from 'react-scroll'
import { NavLink } from 'react-router-dom'
import Logo from '../../images/site_logo/logo.png'
import btnbg from '../../images/shapes/btn_mask_bg.png'
import MobileMenu from '../MobileMenu/MobileMenu';
import Modal from '../Modal/Modal';

const Header = (props) => {

    const [mobailActive, setMobailState] = useState(false);

    const [isSticky, setSticky] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 80) {
                setSticky(true);
            } else {
                setSticky(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        // Clean up
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }


    const [isModalOpen, setIsModalOpen] = useState(false);
    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    return (

        <header className={`site_header header_memecoin  ${isSticky ? 'sticky' : ''}`}>
            <div className="nav_wrapper">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-3 col-5 d-flex align-items-center">
                            <div className="site_logo">
                                <NavLink onClick={ClickHandler} className="site_link" to="/">
                                    <img loading="lazy" src={Logo} alt="ICO Site Logo" />
                                </NavLink>
                            </div>
                        </div>
                        <div className="col-lg-6 col-2">
                            <nav className="main_menu navbar navbar-expand-lg">
                                <div className={`main_menu_inner collapse navbar-collapse justify-content-center ${mobailActive ? 'show' : ''}`} id="main_menu_dropdown">
                                    <ul className="main_menu_list unordered_list text-uppercase main-menu">
                                        <li className="dropdown">
                                            <NavLink onClick={ClickHandler} className="nav-link" to="/" id="homes_submenu" role="button" aria-expanded="false">
                                                <span className="nav_link_label" data-text="Home">Home</span>
                                            </NavLink>
                                        </li>
                                        <li className="dropdown">
                                            <Link to="id_token_offer" className="nav-link" id="services-submenu">
                                                <span className="nav_link_label" data-text="Services">Services</span>
                                                <span className="nav_link_icon">
                                                    <i className="fa-solid fa-angle-down"></i>
                                                </span>
                                            </Link>
                                            <ul className="dropdown-menu" aria-labelledby="services-submenu">
                                                <li>
                                                    <NavLink onClick={ClickHandler} className="dropdown-item" to="/logo-design">
                                                        <span className="nav_link_label">Logo Design</span>
                                                    </NavLink>
                                                </li>
                                                <li>
                                                    <NavLink onClick={ClickHandler} className="dropdown-item" to="/website-design">
                                                        <span className="nav_link_label">Website Design</span>
                                                    </NavLink>
                                                </li>
                                                <li>
                                                    <NavLink onClick={ClickHandler} className="dropdown-item" to="/animation-and-illustration">
                                                        <span className="nav_link_label">Animation and Illustration</span>
                                                    </NavLink>
                                                </li>
                                            </ul>
                                        </li>
                                        <li>
                                            <NavLink onClick={ClickHandler} to="/portfolio" className="nav-link">
                                                <span className="nav_link_label" data-text="Portfolio">Portfolio</span>
                                            </NavLink>
                                        </li>
                                        <li>
                                            <Link href="/id_ico_about_section" spy={true} smooth={true} duration={500} offset={1700} className="nav-link scrollspy_btn">
                                                <span className="nav_link_label" data-text="About">About</span>
                                            </Link>
                                        </li>
                                        <li>
                                            <NavLink onClick={ClickHandler} className="nav-link" to="/contact">
                                                <span className="nav_link_label" data-text="Contact">Contact</span>
                                            </NavLink>
                                        </li>
                                    </ul>
                                    <MobileMenu />
                                </div>
                            </nav>
                        </div>
                        <div className="col-lg-3 col-5">
                            <ul className="btns_group unordered_list p-0 justify-content-end">
                                <li className="d-lg-none">
                                    <button className="mobile_menu_btn" type="button" data-bs-toggle="collapse" data-bs-target="#main_menu_dropdown" aria-expanded="false" aria-label="Toggle navigation" onClick={() => setMobailState(!mobailActive)}>
                                        <i className="far fa-bars"></i>
                                    </button>
                                </li>
                                <li>
                                    <button className="memecoin_btn bg-light" onClick={openModal}>
                                        <span className="btn_label">Get Started</span>
                                        <span className="btn_bg" style={{ maskImage: `url(${btnbg})` }}></span>
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            {isModalOpen && <Modal onClose={closeModal} />}
        </header>
    )
}

export default Header;